import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Checkbox } from '../ui/checkbox';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export const AccessDialog = ({ open, onOpenChange, status, onSaved }) => {
  const [users, setUsers] = useState([]);
  const [sel, setSel] = useState([]);
  useEffect(() => {
    if (!open) return;
    setSel(status.allowed_emails || []);
    axios.get(`${API}/api/users/all`).then((r) => setUsers(r.data.filter((u) => u.role !== 'admin')));
  }, [open, status]);

  const toggle = (email) => setSel((s) => (s.includes(email) ? s.filter((e) => e !== email) : [...s, email]));
  const save = async () => {
    await axios.put(`${API}/api/gmail/access`, { emails: sel });
    toast.success('Accès mis à jour');
    onOpenChange(false);
    onSaved();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="gmail-access-dialog">
        <DialogHeader><DialogTitle>Qui peut utiliser la boîte mail ?</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Les administrateurs ont toujours accès.</p>
        <div className="max-h-80 space-y-2 overflow-y-auto">
          {users.map((u) => (
            <label key={u.email} className="flex items-center gap-2 text-sm cursor-pointer">
              <Checkbox checked={sel.includes(u.email.toLowerCase())} onCheckedChange={() => toggle(u.email.toLowerCase())} data-testid={`gmail-access-${u.email}`} />
              {u.name || u.email} <span className="text-xs text-slate-400">({u.role})</span>
            </label>
          ))}
        </div>
        <Button onClick={save} className="bg-[#1B3170] hover:bg-[#13245a]" data-testid="gmail-access-save">Enregistrer</Button>
      </DialogContent>
    </Dialog>
  );
};
